// extracted by mini-css-extract-plugin
export var address = "styles-module--address--1wwwD";
export var availability = "styles-module--availability--_GmMU";
export var cardLink = "styles-module--cardLink--3Eo5E";
export var careProviderCard = "styles-module--careProviderCard---Ry0z";
export var footer = "styles-module--footer--3oXR0";
export var image = "styles-module--image--3oHh8";
export var imageContainer = "styles-module--imageContainer--990bZ";
export var lighterText = "styles-module--lighterText--Qy9Ag";
export var main = "styles-module--main--3AKtU";
export var moreDetailsIcon = "styles-module--moreDetailsIcon--3Bsfs";
export var padLeftSide = "styles-module--padLeftSide--2wlWP";
export var phoneButton = "styles-module--phoneButton--3I3jL";
export var row = "styles-module--row--3YeOL";
export var side = "styles-module--side--2eDNp";
export var sideWithImage = "styles-module--sideWithImage--2AHg4";
export var stackItem = "styles-module--stackItem--mdLJf";
export var table = "styles-module--table--3LOEq";
export var tall = "styles-module--tall--1jq_W";
export var telButtonRow = "styles-module--telButtonRow--3xnXb";
export var townLabelWrapper = "styles-module--townLabelWrapper--2qtjH";
export var underlineOnHover = "styles-module--underlineOnHover--3F4b9";